import React, {useEffect} from 'react';
import './Modal.scss';
import EditMessage from './EditMessage';

interface ReopenModalProps {
  isModalOpen: boolean;
  isValidComment: boolean;
  aircraftRegistration: string;
  close: () => void;
  confirm: () => void;
  messageChange: () => void;
}

const ReopenModal: React.FC<ReopenModalProps> = ({ isModalOpen, isValidComment, aircraftRegistration, close, confirm, messageChange }) => {
  useEffect(() => {
    
      const closeOnEscapeKeyDown = (e: any) => {
        if ((e.charCode || e.keyCode) === 27) {
          close();
        }
      }
      document.addEventListener('keydown', closeOnEscapeKeyDown);
  
    return () => document.removeEventListener('keydown', closeOnEscapeKeyDown);
    
  }, [isModalOpen]);

  if (!isModalOpen) {
    return null;
  }
  return (
    <div className='modal'>
        <div className='modal-content'>
            <div className='text-wrapper'>
                <div className="header-wrapper">
                    <h2 className="header header_new">Reopen event for {aircraftRegistration}</h2>
                    <button className="close-icon" onClick={close}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.39705 5.55379L5.46967 5.46967C5.73594 5.2034 6.1526 5.1792 6.44621 5.39705L6.53033 5.46967L12 10.939L17.4697 5.46967C17.7359 5.2034 18.1526 5.1792 18.4462 5.39705L18.5303 5.46967C18.7966 5.73594 18.8208 6.1526 18.6029 6.44621L18.5303 6.53033L13.061 12L18.5303 17.4697C18.7966 17.7359 18.8208 18.1526 18.6029 18.4462L18.5303 18.5303C18.2641 18.7966 17.8474 18.8208 17.5538 18.6029L17.4697 18.5303L12 13.061L6.53033 18.5303C6.26406 18.7966 5.8474 18.8208 5.55379 18.6029L5.46967 18.5303C5.2034 18.2641 5.1792 17.8474 5.39705 17.5538L5.46967 17.4697L10.939 12L5.46967 6.53033C5.2034 6.26406 5.1792 5.8474 5.39705 5.55379L5.46967 5.46967L5.39705 5.55379Z" fill="#626B79"/>
                        </svg>
                    </button>
                </div>
                <p className="reopen-text reopen_new">Are you sure you want to reopen this event?</p>
                <div key="reopenMessage" className="reopen-comment-fullWidth">
                   <EditMessage key="reopenMessageBox" className="edit-comment-box" onMessageDataChange={messageChange} initialMessage={""} forModal={true} />
                </div>
                <div className='button-wrapper-start'>
                  <auro-button variant="primary" fluid onClick={confirm}
                  class={
                    isValidComment
                      ? ""
                      : "disabled"
                  }>
                      <span className="btnlabel-white">Yes, Reopen this event</span>
                  </auro-button>
                </div>
            </div>            
        </div>
    </div>
    
  );
}

export default ReopenModal;